(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name dades.llicenciaFormulari.controller:LlicenciaFormulariCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .controller('EntitatsMainLlicenciesFormulariCtrl', EntitatsMainLlicenciesFormulariCtrl);

  function EntitatsMainLlicenciesFormulariCtrl(LlicenciaFactory, entitatData, Notification, llicenciaData, $locale, $rootScope, $state, $stateParams, ProducteBotigaFactory,tyksentitatData,AplicacioFactory,$scope) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlicenciesFormulariCtrl';

    vm.entitat    = entitatData.data;
    vm.llicencia  = llicenciaData.data;
    vm.onchangeproducte=onchangeproducte;
    vm.tyks=tyksentitatData.data;
    vm.listtyks=[];
    vm.listtyksitec=[];

    for (var i=0;i<vm.tyks.list.length;i++){
      vm.listtyks.push(vm.tyks.list[i]);
    }
    for (var i=0;i<vm.tyks.list.length;i++){
      if (vm.tyks.list[i].esitec){
        vm.listtyksitec.push(vm.tyks.list[i]);
      }
    }
    vm.aplicacions=[];
    if (angular.isUndefined(vm.llicencia)){
      vm.llicencia = {
        entitat : vm.entitat,
        demo:false,
        botiga:false,
        renovacio:false/*,
        numero:1*/
      }
    }


    vm.formulari = {
        nom: 'formulari',
        func: func,
        camps: [
          {
            type: 'select',
            name: 'producte',
            label: 'DEFAULT_PRODUCTE',
            propertyLabel: 'nom',
            required: true,
            columns: 6,
            onChange:onchangeproducte
          },
          {
            type: 'datepicker',
            name: 'caducitat',
            label: 'DEFAULT_DATA_CADUCITAT',
            required: true,
            columns: 6
          },
          {
            type: 'numeric',
            name: 'numero',
            label: 'DEFAULT_NUMERO',
            required: true,
            columns: 3,
            decimalPlaces:0
          },
          {
             type: 'checkbox',
             name: 'botiga',
             label: 'botiga',
             columns: 12
          },
          {
             type: 'checkbox',
             name: 'demo',
             label: 'demo',
             columns: 12
          },
          {
             type: 'checkbox',
             name: 'renovacio',
             label: 'renovacio',
             columns: 12
          }
          ]
      };

    ProducteBotigaFactory.getAll().then(function(response){
      vm.formulari.camps[0].list = [];
      for (var i=0;i<response.data.list.length;i++){
        if ($locale.localeID === response.data.list[i].idioma){
          vm.formulari.camps[0].list.push(response.data.list[i]);
        }
      }
    }).catch(function(error){
      Notification.processError(error);
    });

    vm.errors = [];
    vm.back = back;

    function onchangeproducte(){
      vm.showme = true;
      if (!angular.isUndefined(vm.llicencia.producte)){
        if (!angular.isUndefined(vm.llicencia.producte.id)){

            var promise=AplicacioFactory.getAplicacionsProducte(vm.llicencia.producte.id,$stateParams.idEntitat).then(function (response){
                $scope.$evalAsync(function(){
                vm.aplicacions=[];
                  angular.forEach(response.data.list, function(entrada) {
                    vm.aplicacions.push(entrada);
                  });
                });
              }).catch(function(error){
                vm.errors = Notification.processError(error);
              });
            return promise;
        }
      }
    }

    function func(){
      vm.llicencia.listaplicaciotyk=vm.aplicacions;
      if ($stateParams.isNew){
          var promise=LlicenciaFactory.add($stateParams.idEntitat,vm.llicencia).then(function (response){
            vm.llicencia.id = response.data.id;
            if (!angular.isUndefined(response.data.error)){
                $stateParams.errorproces=response.data.error;
            }
            $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
          return promise;
      }
      else {
          var promise=LlicenciaFactory.update($stateParams.idEntitat, vm.llicencia.id, vm.llicencia).then(function (response){
             $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
          return promise;
      }

    }

    function back() {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
    }

    if (!angular.isUndefined($stateParams.isNew) && $stateParams.isNew !== null && $stateParams.isNew) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    } else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  }
}());
